import React from "react";
import { bool, node, string } from "prop-types";
import { classes } from "@insightfulscience/atomic-react/utils/classes";
import { Row } from "../Grid";

const Feature = ({ top = false, middle = true, children, className = "", ...props }) => {
	const alignProps =
		top === true
			? {
					start: true,
					middle: false,
			  }
			: {
					start: false,
					middle,
			  };
	return (
		<Row px className={classes("feature", className)} {...alignProps} {...props}>
			{children}
		</Row>
	);
};

Feature.propTypes = {
	top: bool,
	middle: bool,
	children: node.isRequired,
	className: string,
};

export default Feature;
